import { createContext } from "react";

const ExportDisabledContext = createContext(false);

export default ExportDisabledContext;
